module.exports = __webpack_public_path__ + "img/success.b6d2fc97.png";